module.exports = __webpack_public_path__ + "static/media/dsc5080.010e808f.jpg";